var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCartSad = function SvgCartSad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 231.332 229.089"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6770",
    transform: "translate(-29.672 8)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5148"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5143",
    fill: "none",
    stroke: "#102b3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3116",
    d: "M90.901 74.884H37.672l25.019 100.11a50.285 50.285 0 0 0 48.776 38.1h67.742a50.285 50.285 0 0 0 48.776-38.1l25.019-100.11H129.617"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3117",
    d: "M90.901 101.623V36.832A36.838 36.838 0 0 1 127.733 0h35.21a36.838 36.838 0 0 1 36.832 36.832v64.791"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3490",
    d: "M127.506 181.003c.015-8.963 7.267-12.919 16.206-12.919h8.919c8.949 0 16.206 3.971 16.206 12.919"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 459",
    cx: 11.579,
    cy: 5.976,
    rx: 11.579,
    ry: 5.976,
    transform: "translate(94.53 143.894)",
    fill: "#ffced3"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 455",
    cx: 10.085,
    cy: 10.085,
    r: 10.085,
    transform: "translate(110.218 115.506)",
    fill: "#102b3f"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 456",
    cx: 10.085,
    cy: 10.085,
    r: 10.085,
    transform: "translate(159.523 115.506)",
    fill: "#102b3f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 458",
    cx: 11.579,
    cy: 5.976,
    rx: 11.579,
    ry: 5.976,
    transform: "translate(174.464 143.894)",
    fill: "#ffced3"
  }))));
};
export default SvgCartSad;